import { render, staticRenderFns } from "./SettingButton.vue?vue&type=template&id=5a8a38c5&scoped=true"
import script from "./SettingButton.vue?vue&type=script&lang=js"
export * from "./SettingButton.vue?vue&type=script&lang=js"
import style0 from "./SettingButton.vue?vue&type=style&index=0&id=5a8a38c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a38c5",
  null
  
)

export default component.exports